import 'bootstrap/dist/css/bootstrap.css';
import '@/sass/main.sass';

import 'bootstrap';
import 'babel-polyfill';
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VeeValidate from 'vee-validate';
import panZoom from 'vue-panzoom';
// import SocialSharing from 'vue-social-sharing';
import VueGtag from 'vue-gtag';
import App from './App.vue';
import store from './vuex/store';
import router from './router';


Vue.use(panZoom);
// Vue.use(SocialSharing);
Vue.use(VueAxios, axios);
Vue.use(VeeValidate, {
    inject: true,
});

Vue.use(VueGtag, {
    config: { id: 'UA-155061335-1' },
}, router);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
